import { ManipulableObject } from '../Shared/ManipulableObject';

export abstract class BaseElement extends ManipulableObject {}
